var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "info-container",
      class: { "device-coordi": _vm.isDevicetest },
    },
    [
      _c("div", { staticClass: "column-container" }, [
        _c("div", { staticClass: "column-title" }, [
          _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.studyTitle"))),
        ]),
        _c("div", { staticClass: "column-message" }, [
          _vm._v(_vm._s(_vm.roomTitle)),
        ]),
      ]),
      _c("div", { staticClass: "column-container" }, [
        _c("div", { staticClass: "column-title" }, [
          _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.host"))),
        ]),
        _vm.hostProfileImageUrl
          ? _c("img", {
              staticClass: "user-profile-image",
              attrs: { src: _vm.hostProfileImageUrl, alt: "image" },
            })
          : _c("div", { staticClass: "user-image-none" }),
        _c("div", { staticClass: "column-message" }, [
          _vm._v(_vm._s(_vm.hostNickname)),
        ]),
      ]),
      _c("div", { staticClass: "column-container" }, [
        _c("div", { staticClass: "column-title" }, [
          _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.capacity"))),
        ]),
        _c("div", { staticClass: "column-message" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("camstudy.coordi.roomInfo.participants", {
                  0: _vm.maxCnt,
                })
              )
          ),
        ]),
      ]),
      _c("div", { staticClass: "column-container" }, [
        _c("div", { staticClass: "column-title" }, [
          _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.period"))),
        ]),
        _c("div", { staticClass: "column-message" }, [
          _vm._v(_vm._s(_vm.startDate) + " ~ " + _vm._s(_vm.endResvDate)),
        ]),
      ]),
      _c("div", { staticClass: "column-container" }, [
        _c("div", { staticClass: "column-title" }, [
          _vm._v(_vm._s(_vm.$t("camstudy.coordi.roomInfo.notice"))),
        ]),
        _c("div", { staticClass: "column-message" }, [
          _vm._v(_vm._s(_vm.studyContent)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }